var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4648 18.6542C21.0417 16.8866 22 14.5552 22 12C22 9.57226 21.1349 7.34659 19.6961 5.61444L16.1299 9.18064C16.6789 9.98329 17 10.9541 17 12C17 13.1742 16.5952 14.2539 15.9176 15.1071L19.4648 18.6542Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.107 8.08225L18.6541 4.5351C16.8864 2.9583 14.5551 2 12 2C9.44489 2 7.1136 2.95829 5.34592 4.53507L8.89308 8.08223C9.74628 7.4047 10.8259 7 12 7C13.1741 7 14.2538 7.40471 15.107 8.08225Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3854 19.6962C16.6533 21.1349 14.4277 22 12 22C9.57235 22 7.34674 21.1349 5.61462 19.6962L9.17156 16.1393L9.18074 16.13C9.98337 16.6789 10.9542 17 12 17C13.0458 17 14.0167 16.6789 14.8193 16.1299L14.8284 16.1392L18.3854 19.6962Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 14.5552 2.95836 16.8866 4.53524 18.6543L8.08239 15.1071C7.40477 14.2539 7 13.1742 7 12C7 10.9541 7.32112 9.98326 7.87013 9.18061L4.30393 5.61441C2.86514 7.34656 2 9.57225 2 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifering);
export default __webpack_public_path__ + "static/media/lifering.41c06fe479a11b5b4e6a353c53f2e59f.svg";
export { ForwardRef as ReactComponent };